// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { FC, useState, useEffect, useCallback, useMemo } from "react";
// eslint-disable-next-line node/no-missing-import
import { useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";
// antd:
// import { Switch, Radio, Menu } from "antd";
// Components:
import AppIcons from "./AppIcons.tsx";
import DivE from "./DivE.tsx";
// Redux-hooks:
import { useAppSelector } from "../../libs/redux-hooks.ts";
// Reducers:
import { getLng, getShowDesktopIconsTitle } from "../../libs/reducer.ts";
// Types
import type {Tapp} from "../../types/uiapp.d.ts";

type componentProps = {
  app:Tapp, onAppClick?:(e:React.MouseEvent) => void
};

const OneDesktopIcon:FC<componentProps> = (props) => {
  // const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const lng = useAppSelector(getLng);
  const showDesktopIconsTitle = useAppSelector(getShowDesktopIconsTitle);
  const rlng = (lng === "en" ? "ru" : "en");

  const [clicked, setClicked] = useState("");
  const [opening, setOpening] = useState(false);

  const onMouseDown = useCallback(() => {
    setClicked("clicked"); setOpening(true);
  }, []);

  const onTouchStart = useCallback((e) => {
    if (e.type === "touchstart") { setClicked("clicked"); setOpening(true) }
  }, []);

  const onMouseUp = useCallback((e) => {
    if (opening) {
      const isCtrlPressed = (e.ctrlKey || e.metaKey);
      if (props.onAppClick) { props.onAppClick(e) }
      if (props.app.type === "link") { window.location.href = props.app.link || "/"; return }
      if (props.app.target === "_blank" || isCtrlPressed) { window.open(props.app.link || "/app", "_blank", "noopener,noreferrer"); return }
      navigate(props.app.link || "/app"); // {state: {from: window.location.pathname}, replace: true}
    }
    setClicked(""); setOpening(false);
  }, [navigate, opening, props]);

  const onTouchEnd = useCallback((e) => {
    if (e.type === "touchend" && opening) {
      if (props.onAppClick) { props.onAppClick(e) }
      if (props.app.type === "link") { window.location.href = props.app.link || "/"; return }
      navigate(props.app.link || "/app"); // {state: {from: window.location.pathname}, replace: true}
    }
    setClicked(""); setOpening(false);
  }, [navigate, opening, props]);

  const onMouseMove = useCallback(() => {
    setOpening(false);
  }, []);

  const onTouchMove = useCallback((e) => {
    if (e.type !== "touchmove") { return }
    setOpening(false);
  }, []);

  useEffect(() => {
    document.addEventListener("mouseup", onMouseUp);
    document.addEventListener("touchend", onTouchEnd);
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("touchmove", onTouchMove);

    return () => {
      document.removeEventListener("mouseup", onMouseUp);
      document.removeEventListener("touchend", onTouchEnd);
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("touchmove", onTouchMove);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onMouseUp, onTouchEnd, onMouseMove, onTouchMove]);

  const icoTooltip = useMemo(() => (
    props.app["title_" + lng] || props.app["title_" + rlng] || props.app.title || ""
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ), [lng, props.app]);

  const icoTitle = useMemo(() => {
    const ttl = props.app["title_" + lng] || props.app["title_" + rlng] || props.app.title || "";
    return (ttl.length > 32 ? ttl.slice(0, 30) + "..." : ttl);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lng, props.app]);

  return (
    <DivE className="dragMe" uk-tooltip={icoTooltip}
      onMouseDown={onMouseDown} onTouchStart={onTouchStart}
      style={{cursor: "pointer"}}
    >
      <DivE className="uk-grid uk-child-width-1-1 uk-flex uk-flex-center">
        <DivE key={props.app.key + "-icon"} className="rz-width-1-1 uk-flex uk-flex-center">
          <AppIcons icopath={props.app.icon || "ai/AiFillCodeSandboxSquare"} attrs={{
            size: 60, color: props.app.iconColor, className: (props.app.iconClass || "") + " svg-shadow-hover " + clicked
          }} />
        </DivE>
        <DivE key={props.app.key + "-title"} className="rz-width-1-1 uk-text-center txt-white" style={{fontSize: "0.9em"}}>
          {showDesktopIconsTitle ? icoTitle : undefined}
        </DivE>
      </DivE>
    </DivE>
  );
}

export default OneDesktopIcon;
